export default "__VITE_ASSET__ab8b6550__"